export const DATE_IMAGE_SELECTED = 'DATE_IMAGE_SELECTED';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/dateImageSelected.js